/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { ViewChild, ElementRef, Renderer2, Component, Input, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, IcecontrolPermission } from '../../components/models/icesettings';
import { IcepanelComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { userTypes } from '../../login/login.config';

@Component({
  selector: 'icesplitbutton',
  templateUrl: './icesplitbutton.component.html',
  styleUrls: ['./icesplitbutton.component.scss']
})
export class IcesplitbuttonComponent implements OnInit {
  @Input() id: string = "";
  @Input() buttonSettings: IcecontrolSettings = null;
  btnText: string = "";
  @Output() ButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() MenuItemClick: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iconClass: string = "";
  menuItems: string[] = [];
  permission: IcecontrolPermission = null;
  userAccess = userTypes.USER_FEATURE_ACCESS;

  constructor(private elem: ElementRef,
    private renderer: Renderer2, public router: Router) { }

  ngOnInit() {
    this.permission = this.buttonSettings.permissions ? this.buttonSettings.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);

    if (Iceutility.isdefined(this.buttonSettings) && Iceutility.isdefined(this.buttonSettings.properties)) {
      if (Iceutility.isdefined(this.buttonSettings.properties.menuItems)) {
        this.menuItems = this.buttonSettings.properties.menuItems;
      }

      this.btnText = this.buttonSettings.properties["text"];
      this.id = this.buttonSettings.id;
      let btnElem = this.elem.nativeElement.children[0];

      if (Iceutility.isdefined(this.buttonSettings.properties["glyphClass"])) {
        this.iconClass = "fas " + this.buttonSettings.properties["glyphClass"];
      }

      if (Iceutility.isdefined(this.buttonSettings.properties["class"]) &&
        this.buttonSettings.properties["class"].constructor.name === "Array") {
        let classObj = this.buttonSettings.properties["class"];

        for (let icls = 0; icls < classObj.length; icls++) {
          var obj = classObj[icls];
          if (obj === null || obj === undefined) {
            continue;
          }

          this.renderer.addClass(btnElem, obj);
        }
      }
    }
  }

  isDisabled(): boolean {
    return this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly;
  }

  OnButtonClick(event) {
    event.buttonSettings = this.buttonSettings;
    this.ButtonClick.emit(event);
  }

  OnMenuItemClick(event, item) {
    event.buttonSettings = this.buttonSettings;
    event.clickedItem = item;
    this.MenuItemClick.emit(event);
  }
}
